import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { WaveformVisualizer } from "../WaveformVisualizer";

type Props = {
	isRecording: boolean;
	isRecorded: boolean;
	progress: number;
	meterHistory: number[];
	onSeek?: (progress: number) => Promise<void>;
};

const RecorderWaveform = ({
	isRecording,
	isRecorded,
	progress,
	meterHistory,
	onSeek,
}: Props) => {
	const theme = useAppTheme();
	return (
		<Box flex={1}>
			<WaveformVisualizer
				mode={isRecording ? "recorder" : "default"}
				progress={isRecording ? 1 : progress}
				recordingProgress={isRecording ? progress : undefined}
				activeColor={theme.colors.primary}
				inactiveColor={theme.colors.outlineVariant}
				maxHeight={24}
				meterHistory={meterHistory}
				onSeek={onSeek}
				canSeek={!isRecording}
				cursor={isRecorded ? "pointer" : undefined}
			/>
		</Box>
	);
};

export default RecorderWaveform;
